import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import * as httpClient from "../../../util/httpClient";
import { useHistory } from "react-router-dom";
import i18nService from "../../../util/Internationalization/i18n/i18n";
import { STEP_NOTIFICATION_PREFERENCE, STEP_PERSONAL_INFORMATION_ADDRESS_INFORMATION } from "../ReCompleteRegistrationUtil";
import PhoneInput, { parsePhoneNumber } from "react-phone-number-input";
import { isValidPhoneNo } from "../../../util/phoneNumberValidationUtil";
import { useButtonText } from "../../commonConstants";
interface IProps {
    reCompleteRegistrationState?: any;
    setReCompleteRegistrationState?: any;
}

const TwoFactorMFAForm = ({ reCompleteRegistrationState, setReCompleteRegistrationState }: IProps) => {
    const { register, handleSubmit, errors, watch, control } = useForm({
        mode: "onTouched",
        criteriaMode: "all",
    });
    let history = useHistory();
    let countryValue = i18nService.get("Country");
    if (!countryValue) countryValue = "US";

    const [state, setState] = useState({
        code: "",
        enterCode: true,
        submitCode: false,
        errorMessage: "",
        maximumAttemptReached: false,
        SuccessfulCode: false,
        isDisable: true,
        isLoading: false,
        deliverMethod: "",
        phoneNumber: reCompleteRegistrationState.phone,
        MfaSmsNumber: reCompleteRegistrationState.phone,
        MfaVoiceCallNumber: reCompleteRegistrationState.phone,
        PersonalCountry: reCompleteRegistrationState.country ? reCompleteRegistrationState.country : countryValue,
    });

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const [isNextOrContinue, isPreviousOrBack] = useButtonText();
    const setCommMethod = (e: any) => {
        setState({
            ...state,
            [e.target.name]: e.target.value,
        });
    };

    const setCode = (e: any) => {
        setState({
            ...state,
            [e.target.name]: e.target.value,
        });
    };

    const submitCode = () => {
        const requestBody = {
            SecurityCode: state.code,
        };

        httpClient.sendRequest("POST", "web/Registration/VerifyRegistrationMFA", requestBody).then((data: any) => {
            if (data && data["isSuccess"]) {
                setReCompleteRegistrationState({
                    ...reCompleteRegistrationState,
                    step: STEP_NOTIFICATION_PREFERENCE,
                });
            }

            if (data && data["hasError"]) {
                if (data && data.status) {
                    switch (data.status) {
                        case "INTERNAL_ERROR":
                            history.push("/register/error");
                            break;
                        default:
                            history.push("/register/error");
                            break;
                    }
                } else {
                    setState({ ...state, errorMessage: "Your Authentication Code is incorrect." });
                }
            }
        });
    };

    const resendCode = () => {
        setState((prevState) => ({ ...prevState, submitCode: false, SuccessfulCode: false, enterCode: true, errorMessage: "", isDisable: true }));
    };

    const onSubmit = (data1: any) => {
        if (state.submitCode) {
            return;
        }
        setState({ ...state, isLoading: true, errorMessage: "" });
        let number =
            state.deliverMethod === "1"
                ? getCountryInfo()
                    ? data1.MfaSmsNumber.replace(/[^0-9+]/g, "")
                    : data1.MfaSmsNumber
                : state.deliverMethod === "3"
                ? getCountryInfo()
                    ? data1.MfaVoiceCallNumber.replace(/[^0-9+]/g, "")
                    : data1.MfaVoiceCallNumber
                : getCountryInfo()
                ? reCompleteRegistrationState.phone.replace(/[^0-9]/g, "")
                : reCompleteRegistrationState.phone;

        const requestBody = {
            mfaNotificationMethod: Number(state.deliverMethod),
            emailId: reCompleteRegistrationState.email,
            personalPhoneNo: number,
            PersonalCountry: state.PersonalCountry,
        };

        httpClient.sendRequest("POST", "web/Registration/send-re-complete-mfa-secureCode", requestBody).then((data: any) => {
            if (data && data["isSuccess"]) {
                setState({
                    ...state,
                    submitCode: true,
                    SuccessfulCode: false,
                    enterCode: false,
                    isDisable: false,
                    isLoading: false,
                    MfaSmsNumber: data1.MfaSmsNumber ? data1.MfaSmsNumber : reCompleteRegistrationState.phone,
                    MfaVoiceCallNumber: data1.MfaVoiceCallNumber ? data1.MfaVoiceCallNumber : reCompleteRegistrationState.phone,
                });
                return;
            }
            if (data && data["hasError"]) {
                if (data && data.status) {
                    switch (data.status) {
                        case "INTERNAL_ERROR":
                            history.push("/register/error");
                            break;
                        default:
                            history.push("/register/error");
                            break;
                    }
                } else {
                    history.push("/register/error");
                }
            }
            setState({ ...state, isLoading: false });
        });
        window.addToDataLayer({ event: "Submit Two Factor MFA Form" });
    };

    const setPrevious = () => {
        setReCompleteRegistrationState({
            ...reCompleteRegistrationState,
            step: STEP_PERSONAL_INFORMATION_ADDRESS_INFORMATION,
        });
    };

    const getCountryInfo = () => {
        let currentCountry = countryValue;
        if (currentCountry.includes("US") || currentCountry.includes("CA")) {
            return false;
        } else {
            return true;
        }
    };

    useEffect(() => {
        const el = document.getElementsByClassName("PhoneInputCountry");
        if (el && el.length > 0) {
            try {
                const childs = el[0].children;
                if (childs[0].nodeName === "SELECT") {
                    const selectEl = childs[0] as HTMLSelectElement;
                    selectEl.disabled = true;
                }
            } catch {}
        }
    }, [state.deliverMethod]);

    return (
        <div className={state.isLoading ? "box-content loading" : "box-content"}>
            <form id="form-MFA" onSubmit={handleSubmit(onSubmit)}>
                <div className="row between-sm">
                    <div className="col-xs-12  col-no-gutter">
                        <p>
                            For your protection, we provide two-factor authentication as additional security for your account. We will send you an authentication
                            code. Please select a delivery option to receive your code.
                        </p>
                        <div className="margin-bottom-l"></div>
                    </div>
                </div>

                <div className="col-xs-12 col-sm-12 col-no-gutter">
                    <fieldset className="form-row inline">
                        <div className="row">
                            <div className={`form-row inline row}`}>
                                <div className="form-label col-xs-12 col-sm-3 col-no-gutter">
                                    <label htmlFor="label-delivery-method">Delivery Method</label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-5 col-no-gutter">
                                    <select
                                        className="inputbox"
                                        id="label-delivery-method"
                                        ref={register({ required: true })}
                                        defaultValue={state.deliverMethod}
                                        name="deliverMethod"
                                        onChange={(e) => setCommMethod(e)}
                                    >
                                        <option value="">Select</option>
                                        <option value="0">Email</option>
                                        <option value="1">Text Message</option>
                                        <option value="3">Voice Call</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                    {state.deliverMethod === "0" && (
                        <fieldset className="form-row inline">
                            <div className="row">
                                <div className={`form-row inline row}`}>
                                    <div className="form-label col-xs-12 col-sm-3 col-no-gutter">
                                        <label htmlFor="label-delivery-method-email">Email</label>
                                    </div>
                                    <div className="form-label col-xs-12 col-sm-5 col-no-gutter">
                                        <label htmlFor="label-delivery-method-email-1">{reCompleteRegistrationState.email}</label>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    )}
                    {state.deliverMethod === "1" && (
                        <fieldset className="form-row inline">
                            <div className="row">
                                <div
                                    className={`form-row row inline ${errors["MfaSmsNumber"] && "status-error"} ${
                                        errors["MfaSmsNumber"] && watch("MfaSmsNumber") && !parsePhoneNumber(watch("MfaSmsNumber")) ? "country-error" : ""
                                    }`}
                                >
                                    <div className="form-label col-xs-12 col-sm-3 col-no-gutter">
                                        <label htmlFor="label-phone-number1">Mobile Number</label>
                                    </div>
                                    <div className="form-input col-xs-12 col-sm-5 col-no-gutter">
                                        <Controller
                                            name={"MfaSmsNumber"}
                                            control={control}
                                            defaultValue={state.MfaSmsNumber ? state.MfaSmsNumber : ""}
                                            className="inputbox"
                                            rules={{
                                                required: true,
                                                validate: (value) =>
                                                    value
                                                        ? isValidPhoneNo(
                                                              reCompleteRegistrationState && reCompleteRegistrationState.country
                                                                  ? reCompleteRegistrationState.country
                                                                  : "US",
                                                              value
                                                          )
                                                        : false,
                                            }}
                                            render={({ onChange, value }) => (
                                                <PhoneInput
                                                    value={value}
                                                    onChange={onChange}
                                                    international={false}
                                                    addInternationalOption={false}
                                                    defaultCountry={reCompleteRegistrationState.country ? reCompleteRegistrationState.country : "US"}
                                                    countries={[reCompleteRegistrationState.country ? reCompleteRegistrationState.country : "US"]}
                                                    id="label-phone-number1"
                                                    placeholder="Enter Mobile number"
                                                    maxLength={15}
                                                    minLength={10}
                                                />
                                            )}
                                        />
                                        {!!errors["MfaSmsNumber"] && errors["MfaSmsNumber"].type === "required" && (
                                            <span className="form-error">Mobile is required</span>
                                        )}
                                        {!!errors["MfaSmsNumber"] && errors["MfaSmsNumber"].type === "validate" && (
                                            <span className="form-error">Invalid format. Please enter a valid mobile number.</span>
                                        )}
                                        {!!errors["MfaSmsNumber"] &&
                                            errors["MfaSmsNumber"].type === "minLength" &&
                                            (getCountryInfo() ? (
                                                <span className="form-error">Mobile Number must be a minimum of 7 digits in length.</span>
                                            ) : (
                                                <span className="form-error">Invalid format. Mobile Number must be 10 digits in length.</span>
                                            ))}
                                        {!!errors["MfaSmsNumber"] &&
                                            errors["MfaSmsNumber"].type === "maxLength" &&
                                            (getCountryInfo() ? (
                                                <span className="form-error">Mobile Number must be a maximum of 15 digits in length.</span>
                                            ) : (
                                                <span className="form-error">Invalid format. Mobile Number must be 10 digits in length.</span>
                                            ))}
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    )}
                    {state.deliverMethod === "3" && (
                        <fieldset className="form-row inline">
                            <div className="row">
                                <div
                                    className={`form-row row inline ${errors["MfaVoiceCallNumber"] && "status-error"} ${
                                        errors["MfaVoiceCallNumber"] && watch("MfaVoiceCallNumber") && !parsePhoneNumber(watch("MfaVoiceCallNumber"))
                                            ? "country-error"
                                            : ""
                                    }`}
                                >
                                    <div className="form-label col-xs-12 col-sm-3 col-no-gutter">
                                        <label htmlFor="label-phone-number2">Mobile Number</label>
                                    </div>
                                    <div className="form-input col-xs-12 col-sm-5 col-no-gutter">
                                        <Controller
                                            name={"MfaVoiceCallNumber"}
                                            control={control}
                                            defaultValue={state.MfaVoiceCallNumber ? state.MfaVoiceCallNumber : ""}
                                            className="inputbox"
                                            rules={{
                                                required: true,
                                                validate: (value) =>
                                                    value
                                                        ? isValidPhoneNo(
                                                              reCompleteRegistrationState && reCompleteRegistrationState.country
                                                                  ? reCompleteRegistrationState.country
                                                                  : "US",
                                                              value
                                                          )
                                                        : false,
                                            }}
                                            render={({ onChange, value }) => (
                                                <PhoneInput
                                                    value={value}
                                                    onChange={onChange}
                                                    international={false}
                                                    addInternationalOption={false}
                                                    defaultCountry={reCompleteRegistrationState.country ? reCompleteRegistrationState.country : "US"}
                                                    countries={[reCompleteRegistrationState.country ? reCompleteRegistrationState.country : "US"]}
                                                    id="label-phone-number2"
                                                    placeholder="Enter Mobile number"
                                                    maxLength={15}
                                                    minLength={10}
                                                />
                                            )}
                                        />
                                        {!!errors["MfaVoiceCallNumber"] && errors["MfaVoiceCallNumber"].type === "required" && (
                                            <span className="form-error">Mobile is required</span>
                                        )}
                                        {!!errors["MfaVoiceCallNumber"] && errors["MfaVoiceCallNumber"].type === "validate" && (
                                            <span className="form-error">Invalid format. Please enter a valid mobile number.</span>
                                        )}
                                        {!!errors["MfaVoiceCallNumber"] &&
                                            errors["MfaVoiceCallNumber"].type === "minLength" &&
                                            (getCountryInfo() ? (
                                                <span className="form-error">Mobile Number must be a minimum of 7 digits in length.</span>
                                            ) : (
                                                <span className="form-error">Invalid format. Mobile Number must be 10 digits in length.</span>
                                            ))}
                                        {!!errors["MfaVoiceCallNumber"] &&
                                            errors["MfaVoiceCallNumber"].type === "maxLength" &&
                                            (getCountryInfo() ? (
                                                <span className="form-error">Mobile Number must be a maximum of 15 digits in length.</span>
                                            ) : (
                                                <span className="form-error">Invalid format. Mobile Number must be 10 digits in length.</span>
                                            ))}
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    )}
                </div>
                {(state.deliverMethod === "1" || state.deliverMethod === "0" || state.deliverMethod === "3") && (
                    <div className="row between-sm col-xs-12 col-sm-12 col-no-gutter">
                        <div className="col-xs-12 col-sm-3 col-no-gutter"></div>
                        <div className="col-xs-12 col-sm-9 col-no-gutter">
                            <p>
                                To complete your registration, you will be asked to enter the authentication code sent to you by the selected delivery option above.
                                Once you get the code, enter it in the field and click submit.
                            </p>
                            <div className="margin-bottom-l"></div>
                        </div>
                    </div>
                )}
                {state.enterCode && (state.deliverMethod === "1" || state.deliverMethod === "0" || state.deliverMethod === "3") && (
                    <div className="row between-sm col-xs-12 col-sm-12 col-no-gutter">
                        <div className="col-xs-12 col-sm-3 col-no-gutter"></div>
                        <div className="col-xs-12 col-sm-9 col-no-gutter">
                            <button type="submit" className="btn-default btn-primary btn-min-width">
                                <span className="btn-text">Send Code</span>
                            </button>
                        </div>
                    </div>
                )}
                {state.submitCode && (
                    <div className="col-xs-12 col-sm-12 col-no-gutter">
                        <fieldset className="form-row inline">
                            <div className="row">
                                <div className={`form-row inline row}`}>
                                    <div className="form-label col-xs-12 col-sm-3 col-no-gutter">
                                        <label htmlFor="label-code">Code</label>
                                    </div>
                                    <div className="form-input col-xs-12 col-sm-5 col-no-gutter margin-right-s">
                                        <input
                                            type="text"
                                            className="inputbox"
                                            id="label-code"
                                            onChange={(e) => setCode(e)}
                                            placeholder="Enter code here"
                                            ref={register({ required: true })}
                                            name="code"
                                        />
                                    </div>
                                    {state.deliverMethod !== "" && (
                                        <div className="form-input col-xs-12 col-sm-3 col-no-gutter">
                                            <p>
                                                <span className="default_link" onClick={() => resendCode()}>
                                                    <a href="javascript:void(0)" className="default_link">
                                                        Resend Code
                                                    </a>
                                                </span>
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </fieldset>
                    </div>
                )}
                {state.errorMessage.length > 0 && (
                    <div className="row between-sm col-xs-12 col-sm-12 col-no-gutter">
                        <div className="col-xs-12 col-sm-3 col-no-gutter"></div>
                        <div className="col-xs-12 col-sm-9 col-no-gutter">
                            <span className="required">{state.errorMessage}</span>
                        </div>
                    </div>
                )}
                <div className="margin-vertical-l"></div>

                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <ul className="list-inline list-reset">
                            <li className="margin-left-s">
                                <button type="button" className="btn-default btn-default btn-min-width" onClick={() => setPrevious()}>
                                    <span className="btn-text">{isPreviousOrBack}</span>
                                </button>
                            </li>
                            <li className="margin-left-s">
                                <button type="button" onClick={() => submitCode()} className="btn-default btn-primary btn-min-width" disabled={state.isDisable}>
                                    <span className="btn-text">{state.enterCode ? isNextOrContinue : "Submit"}</span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default TwoFactorMFAForm;
